import React from 'react';
import { Button } from '@themesberg/react-bootstrap';
import EditFormActions from './EditFormActions';

export default function RecordEditActions({ formik, backTo, onCancel, saveDisabled = false }) {
  if (!onCancel) {
    return <EditFormActions backTo={backTo} isDirty={formik.dirty}
      saveDisabled={!formik.dirty || saveDisabled} isSubmitting={formik.isSubmitting} />;
  }
  return (
    <div className="create-record-form__actions d-flex justify-content-end gap-2 mt-2">
      <Button variant="outline-secondary" type="button" onClick={onCancel} disabled={formik.isSubmitting}>
        Cancel
      </Button>
      <Button variant="primary" type="submit" className="btn-quote-blue"
        disabled={!formik.dirty || formik.isSubmitting || saveDisabled}>
        {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
      </Button>
    </div>
  );
}
